import { InjectionToken } from '@angular/core';

export const API_URL_TOKEN = new InjectionToken<string>('ApiUrl');
